
// 判断当前页面拥有的按钮 返回值 true--显示  false--隐藏
import qs from 'qs'
export default (routeName) => {
  const btnsArr = qs.parse(sessionStorage.btns) // 当前用户有的权限按钮
  if (btnsArr.hasOwnProperty(routeName)) { // 判断传入的页面name是否在数组之中
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/api/serviceAuth.js